import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { TooltipDirective } from '@core/directives/tooltip.directive';
import { TrendItem, AppearanceEntry } from '../../trends.interface';

@Component({
  selector: 'app-appearances-modal',
  standalone: true,
  imports: [DatePipe, CurrencyPipe, TooltipDirective],
  templateUrl: './appearances-modal.component.html',
  styleUrl: './appearances-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'modal-container flex flex-col' },
})
export class AppearancesModalComponent {
  item = input<TrendItem>();

  itemName = computed(() => this.item()?.name ?? 'Unknown Item');
  entries = computed<AppearanceEntry[]>(() => this.item()?.appearance_entries ?? []);
}
